import { MappedEntity } from '@api/api/entity-schema';
import { TSDatum } from '@api/api/timeseries-schema';
import { RangeHorizon } from '@chart';
import { SparklineChart } from '@terminal/components/sparkline-chart/SparklineChart';
import { ChartPreviewDropdown } from '@terminal/modules/chart-preview-dropdown/ChartPreviewDropdown';
import { POSTHOG_TRACKING_SOURCES } from '@terminal/services/tracking/posthog/constants';
import { useTranslation } from 'react-i18next';

export interface ScreenerTableChartProps {
  entity: MappedEntity;
  data: TSDatum[];
  width: number;
  height: number;
  horizon: RangeHorizon;
}

export const ScreenerTableChart = ({
  entity,
  data,
  width,
  height,
  horizon,
}: ScreenerTableChartProps) => {
  const { t } = useTranslation('common', { useSuspense: false });

  return (
    <ChartPreviewDropdown
      entity={entity}
      horizon={horizon}
      source={POSTHOG_TRACKING_SOURCES.SCREENER}
    >
      <SparklineChart
        aria-label={`${entity.name} ${t('common:sideNavigation.chart')}`}
        data={data}
        dataTestId="screener-table-chart"
        height={height}
        horizon={horizon}
        width={width}
      />
    </ChartPreviewDropdown>
  );
};
